import React from 'react'
// eslint-disable-next-line import/no-extraneous-dependencies
import { ThreeCircles } from 'react-loader-spinner'

// Typage des props
interface LoadingProperties {
  show: boolean;
}
const Loading: React.FC<LoadingProperties> = ({ show }) => {
  // Condition pour retourner null quand `show` est false
  if (!show) return (<></>);

  return (
    <ThreeCircles
      visible={true}
      height="100"
      width="100"
      color="#4fa94d"
      innerCircleColor="#ffffff"
      middleCircleColor="#b01117"
      outerCircleColor="#b01117"
      ariaLabel="three-circles-loading"
      wrapperStyle={{}}
      wrapperClass="z-60"
    />
    

  );
};
export { Loading }